module.exports = __webpack_public_path__ + "img/invoice-de-male-wm-th.eb84fe3f.png";